import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json'; // Assure-toi que ce fichier existe
import en from './locales/en.json'; // Assure-toi que ce fichier existe également

i18n
  .use(initReactI18next) // Passer i18n à React
  .init({
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    lng: 'fr', // Langue par défaut
    fallbackLng: 'en', // Langue de secours
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
  });

export default i18n;
